import type { ConceptDef } from '../types';

export const receptiveFunction: ConceptDef = {
  kind: 'tileMatch',
  id: 'receptive-function',
  label: 'Receptive Function',
  category: 'Receptive',
  description: 'Hear a function and tap the matching item.',
  config: {
    promptMode: 'AUDIO',
    tileCount: 4,
    items: [
      { say: 'you sit on it', answer: '🪑 chair' },
      { say: 'you write with it', answer: '✏ pencil' },
      { say: 'you ride in it', answer: '🚗 car' },
      { say: 'you drink from it', answer: '🥛 cup' },
      { say: 'you wear on your feet', answer: '👟 shoe' },
      { say: 'you read it', answer: '📕 book' },
    ],
  },
};
